import { render, staticRenderFns } from "./AuthFailure.vue?vue&type=template&id=85e5c004&scoped=true"
import script from "./AuthFailure.vue?vue&type=script&lang=js"
export * from "./AuthFailure.vue?vue&type=script&lang=js"
import style0 from "./AuthFailure.vue?vue&type=style&index=0&id=85e5c004&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e5c004",
  null
  
)

export default component.exports